<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onRefresh()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <!-- General -->
        <section class="tw-w-full">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-poll tw-ml-2 mdi-24px"></i>
              {{ pageVocabs + "legends.generalInformation" | translate }}
            </legend>

            <div class="row">
              <!-- deviceId -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  class="tw-w-full"
                  [(value)]="model.deviceId"
                  [control]="form?.get('deviceId')"
                  [label]="fields + 'deviceId'"
                >
                </form-field>
              </div>

              <!-- webhookUrl -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <form-field
                  class="tw-w-full"
                  [(value)]="model.webhookUrl"
                  [control]="form?.get('webhookUrl')"
                  [label]="fields + 'webhookUrl'"
                >
                </form-field>
              </div>

              <!-- isShowDetail -->
              <div
                class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-flex tw-items-center"
              >
                <mat-slide-toggle
                  formControlName="isShowDetail"
                  [(ngModel)]="isShowDetail"
                  (change)="onChangeIsShowDetail()"
                >
                  {{ fields + "isShowDetail" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </fieldset>
        </section>

        <!-- phonebooks -->
        <section class="lg:tw-w-1/2 xl:tw-w-1/3 tw-mt-4">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-account-group tw-ml-2 mdi-24px"></i>
              {{ pageVocabs + "legends.phonebooksList" | translate }}
            </legend>

            <div class="row">
              <div class="tw-w-full tw-my-5">
                <h3 class="tw-mr-3 tw-mb-[12px] dark:tw-text-gray-300">
                  {{ "common.phonebooks" | translate }}
                </h3>
                <div
                  class="tw-flex tw-overflow-y-scroll tw-h-[600px] tw-p-[10px]"
                >
                  <phonebook-selection-list
                    searchLabel="common.search"
                    type="currentOrganizationPhonebooks"
                    (values)="model.phonebookIdList = $event"
                    [showPrivacyDropdown]="false"
                    [values]="model.phonebookIdList"
                    responsiveClass="tw-w-full"
                    searchBoxGridclass="tw-w-full"
                    [isSmallSize]="true"
                  >
                  </phonebook-selection-list>
                </div>
              </div>
            </div>
          </fieldset>
        </section>

        <!-- details -->
        <ng-container *ngIf="isShowDetail">
          <section
            *ngFor="let detail of model.details; let index = index"
            class="lg:tw-w-1/2 xl:tw-w-1/3 tw-mt-4"
          >
            <fieldset class="filter-conditions tw-h-full tw-relative">
              <legend class="tw-flex-center">
                <i class="mdi mdi-message tw-ml-2 mdi-24px"></i>
                {{ pageVocabs + "legends.details" | translate }}
              </legend>

              <app-customer-club-devices-detail
                [formPageConfig]="formPageConfig"
                [organizationId]="input_organizationId"
                [userId]="input_userId"
                [detail]="detail"
                (form)="customerClubDevicesDetailForms[index] = $event"
              ></app-customer-club-devices-detail>

              <!-- remove -->
              <i
                *ngIf="this.model.details.length != 1"
                class="minus mdi mdi-minus mdi-24px"
                [matTooltip]="'common.delete' | translate"
                (click)="onRemoveDetail(index)"
                [style.left.px]="index != model.details?.length - 1 ? 15 : 50"
              >
              </i>
              <!-- add -->
              <i
                *ngIf="index == model.details?.length - 1"
                class="plus mdi mdi-plus mdi-24px"
                [matTooltip]="'common.add' | translate"
                (click)="onAddDetail()"
              >
              </i>
            </fieldset>
          </section>
        </ng-container>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
